import { Dialog } from "@mui/material";
import { useScale, btnDelay } from "common/utils";
import { ParentCloseBtn, FadeTransition } from "common/elements";
import i18n from "features/shared/i18n";
import { FeedbackHistoryItem } from "features/player/types";
import { FeedbackSummaryCard } from "./FeedbackSummaryCard";

interface FeedbackListModalProps {
  feedbackItems: FeedbackHistoryItem[];
  onClose: () => void;
  onSelectItem: (item: FeedbackHistoryItem) => void;
}

export const FeedbackListModal = ({
  feedbackItems,
  onClose,
  onSelectItem,
}: FeedbackListModalProps) => {
  const { width, height, scale } = useScale();
  // 狭い画面（scale下限クランプ時）でも収まるよう、設計サイズを上限に可変にする
  const modalWidth = Math.min(800, width / scale - 16);
  const modalHeight = Math.min(700, height / scale - 8);

  const handleSelectItem = (item: FeedbackHistoryItem) => {
    btnDelay(() => onSelectItem(item));
  };

  return (
    <Dialog
      fullScreen
      open={true}
      maxWidth={false}
      sx={{ zIndex: 99999 }}
      TransitionComponent={FadeTransition}
      PaperProps={{ style: { backgroundColor: "transparent" } }}
    >
      <div className="flex-col-center w-full h-full bg-textcolor-black/50">
        <div style={{ transform: `scale(${scale})` }}>
          <div
            style={{ width: modalWidth, height: modalHeight }}
            className="flex-col-el border-solid border-gray2-30 border-[16px] rounded-[16px] bg-gray2-30"
          >
            <div className="flex-col-el justify-start w-full h-full relative p-6 rounded-[8px] bg-white overflow-hidden">
              <ParentCloseBtn close={onClose} />
              {/* タイトル */}
              <div className="flex-row-el items-center gap-2 mb-4 pb-3 border-b border-outline shrink-0">
                <span className="material-symbols-outlined !text-[54px] text-red-100">forum</span>
                <h2 className="text-[33px] text-textcolor-black">
                  {i18n.t("MSG_PARENT_PAGE_FEEDBACK_HISTORY")}
                </h2>
                <span className="text-[24px] text-gray2-100 ml-1">({feedbackItems.length})</span>
              </div>

              {/* フィードバックリスト */}
              <div className="flex-1 overflow-y-auto invisible-scrollbar min-h-0">
                <div className="flex-col-el gap-3">
                  {feedbackItems.map((item) => (
                    <FeedbackSummaryCard
                      key={item.id}
                      item={item}
                      onClick={() => handleSelectItem(item)}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  );
};
